<!--ACCORDION-->
<ng-container *ngIf="entries && entries.length > 0">
  <div class="accordion">
    <!--NOTE: Accordion should be a list component. Do not modify-->
    <ul
      *ngFor="let entry of entries; let i = index; trackBy: trackByEntriesTitle"
      class="toggle-accordion">
      <!--ACCORDION CATEGORY ITEM-->
      <li
        class="toggle-title font-color-gray"
        (click)="toggleAccordion(i)"
        [class.active]="entry.isExpanded">
        <h4 class="accordion-title cursor">
          <!--CATEGORY TITLE-->
          <span class="bold title-name">{{ entry.title }}</span>
          <!--END CATEGORY TITLE-->
          <!--CARET ARROW EXPAND COLLAPSE ICON-->
          <i class="icon x-small red arrow-down caret-arrow"></i>
          <!--END CARET ARROW EXPAND COLLAPSE ICON-->
        </h4>
      </li>
      <!--END ACCORDION CATEGORY ITEM-->
      <li
        class="toggle-inner"
        [ngClass]="customAccordionContentCss"
        [style.display]="entry.isExpanded ? 'block' : 'none'">
        <!--BODY CONTENT-->
        <div [innerHTML]="entry?.body | safe : 'html'"></div>
        <!--END BODY CONTENT-->
        <ng-container *ngIf="entry?.array && entry?.array.length > 0">
          <!--RESET OR SELECT ALL LINKS-->
          <div class="margin-bottom-small">
            <!--SELECT ALL LINK-->
            <span class="select-or-clear-all">
              <a
                id="select-all-link-{{ entry.id }}"
                attr.data-beyond-link-id="select-all-link-{{ entry.id }}"
                class="gen-primary-link small-link select-all-{{ entry.match }}"
                href="javascript:void(0)"
                (click)="selectAll(entry.array, entry.match, true)">
                Select All
              </a>
            </span>
            <!--END SELECT ALL LINK-->
            <!--DIVIDER-->
            <span class="divider-{{ entry.match }}"> | </span>
            <!--END DIVIDER-->
            <!--SELECT ALL LINK-->
            <span class="select-or-clear-all">
              <a
                id="clear-all-link-{{ entry.id }}"
                attr.data-beyond-link-id="clear-all-link-{{ entry.id }}"
                class="gen-primary-link small-link select-all-{{ entry.match }}"
                href="javascript:void(0)"
                (click)="clearAll(entry.array, entry.match)">
                Clear All
              </a>
            </span>
            <!--END UNSELECT ALL LINK LINKS-->
          </div>
          <!--END RESET OR SELECT ALL-->
          <ul class="custom-filters-{{ entry.match }}">
            <li
              class="flexbox margin-bottom-x-small"
              *ngFor="let item of entry.array; let j = index; trackBy: trackByEntryArrayTitle">
              <!--INPUT CHECKBOX WITH LABEL-->
              <input
                class="form-check-input"
                type="checkbox"
                id="checkbox-id-{{ item.id }}"
                attr.data-beyond-checkbox-id="checkbox-id-{{ item.id }}"
                [(ngModel)]="item.checked"
                (change)="onToggle(entry.array, entry.match)" />
              <!--NOTE: The label for MUST reference the input checkbox for accessiblity and MUST be unique index which consists of the outer index of and the inner index of j-->
              <label
                class="margin-right-smallest"
                attr.data-beyond-id="checkbox-id-{{ item.id }}"
                for="checkbox-id-{{ item.id }}">
                {{ item.title }}
              </label>
              <!--END INPUT CHECKBOX WITH LABEL-->
              <!--INFORMATION TOOLTIP-->
              <ng-container
                *ngIf="
                  entry.match === filterMatchTypes.INSTRUCTION_TYPE ||
                  (entry.match === filterMatchTypes.GENESYS_PRODUCT && item.tooltip !== '')
                ">
                <app-information-tooltip
                  [tooltipData]="item.tooltip"
                  [tooltipIcon]="'info-icon'"
                  [iconSize]="'x-smallest'"
                  [iconColor]="'red'">
                </app-information-tooltip>
              </ng-container>
              <!--END INFORMATION TOOLTIP-->
            </li>
          </ul>
        </ng-container>
      </li>
    </ul>
    <!--NOTE: Add last horizontal rule line since it is the last item in the accordion list-->
    <div class="border-bottom-light-gray"></div>
  </div>
</ng-container>
<!--ACCORDION-->
